export default "__VITE_ASSET__BoCIJrNF__"